import type * as Types from '../../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';

export type GetContentMyLikeQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;

export type GetContentMyLikeQuery = {
  __typename?: 'Query';
  sharryContentBySlug?:
    | {
        __typename?: 'Event';
        id: string;
        slug?: string | null;
        bookmarked?: boolean | null;
        myFollow?: { __typename?: 'Follow'; id: string } | null;
        myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
      }
    | {
        __typename?: 'Post';
        id: string;
        slug?: string | null;
        bookmarked?: boolean | null;
        myFollow?: { __typename?: 'Follow'; id: string } | null;
        myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
      }
    | {
        __typename?: 'Sharry';
        id: string;
        slug?: string | null;
        bookmarked?: boolean | null;
        myFollow?: { __typename?: 'Follow'; id: string } | null;
        myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
      }
    | {
        __typename?: 'Wonder';
        id: string;
        slug?: string | null;
        bookmarked?: boolean | null;
        myFollow?: { __typename?: 'Follow'; id: string } | null;
        myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
      }
    | null;
};

export type GetProfileMyLikeQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;

export type GetProfileMyLikeQuery = {
  __typename?: 'Query';
  userBySlug?: {
    __typename?: 'User';
    id: string;
    bookmarked?: boolean | null;
    myFollow?: { __typename?: 'Follow'; id: string } | null;
    myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
  } | null;
};

export type GetLikeCollectionMyLikeQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;

export type GetLikeCollectionMyLikeQuery = {
  __typename?: 'Query';
  likeCollectionBySlug?: {
    __typename?: 'LikeCollection';
    id: string;
    myFollow?: { __typename?: 'Follow'; id: string } | null;
    myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
  } | null;
};

export const GetContentMyLikeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getContentMyLike' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryContentBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cached' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myFollow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myFavourite' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'bookmarked' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetContentMyLikeGQL extends Apollo.Query<GetContentMyLikeQuery, GetContentMyLikeQueryVariables> {
  document = GetContentMyLikeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetProfileMyLikeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProfileMyLike' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myFollow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myFavourite' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'bookmarked' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetProfileMyLikeGQL extends Apollo.Query<GetProfileMyLikeQuery, GetProfileMyLikeQueryVariables> {
  document = GetProfileMyLikeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetLikeCollectionMyLikeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getLikeCollectionMyLike' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'likeCollectionBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myFollow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myFavourite' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetLikeCollectionMyLikeGQL extends Apollo.Query<
  GetLikeCollectionMyLikeQuery,
  GetLikeCollectionMyLikeQueryVariables
> {
  document = GetLikeCollectionMyLikeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
